import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MedidasService {
  server = 'http://localhost:4040/';
  apiMedidasUrl = '/api/documentos/medidas';
  apiMedidasDownloadFile = '/api/documentos/medidas/downloadfile/';

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'multipart/form-data',
    }),
  };

  constructor(private http: HttpClient) {}

  // Subrutina de conexión para descargar el documento de medidas
  downloadDocument(): Observable<any> {
    return this.http.get(this.apiMedidasDownloadFile, { responseType: 'blob' }).pipe(
      catchError( (err) => {
        console.log('Error: ', err);
        return throwError(err);
      })
    );
  }

  // Subrutina de conexión para obtener los datos de medida
  getMedidas(): any{
    return this.http.get<any>('/api/documentos/medidas/getdata');
  }

  // Subrutina de conexión para subir el documento de medidas
  postDocument(file: FormData, empresaId?): Observable<any> {
    return this.http.post<any>('/api/documentos/medidas/' + empresaId, file);
  }
}
